import {
  PurchasableProduct,
  PurchaseDirection,
  Subscription,
} from '@accedo/one-plugin-sdk';

import { OneError } from '#/errors/oneError';
import { ChangeOrPurchase } from '#/store/paywall/paywall.utils';

export interface Actions {
  handleError: (error: OneError) => void;
  handleClose: () => void;
}

export interface NextSubscriptionDetails
  extends Pick<
    Subscription,
    'id' | 'title' | 'price' | 'duration' | 'currency'
  > {
  direction: PurchaseDirection;
  changeDate?: Date;
  isImmediateSwitch?: boolean;
}

export enum SubscriptionParams {
  Product = 'product',
  Voucher = 'voucher',
}

export enum PurchaseFlowStep {
  PICK = 'PICK',
  PURCHASE = 'PURCHASE',
  CHANGE_ADD_PAYMENT_METHOD = 'CHANGE_ADD_PAYMENT_METHOD',
  CHANGE_CONFIRM = 'CHANGE_CONFIRM',
}

export interface PurchaseFlowStore {
  selectedProduct?: PurchasableProduct;
  direction?: ChangeOrPurchase;
  hasPaymentMethod?: boolean;
}
